<template>
  <div class="sections-container">
    <div class="modern-form">
      <v-container>
        <div v-if="loading" class="loading-container">
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
            class="loading-spinner" />
        </div>
        <v-row v-else>
          <v-col cols="12">
            <div class="info-section">
              <h2 class="section-title">Company Logo</h2>
              <div class="logo-preview">
                <div v-if="convertedLogo" class="logo-container">
                  <v-img :src="convertedLogo" max-width="200" contain></v-img>
                </div>
                <div v-else class="no-logo">No logo uploaded</div>
              </div>
              <v-file-input
                chips
                @change="convertLogo"
                @click:clear="convertedLogo = originalLogo"
                v-model="form.logo"
                prepend-icon="mdi-camera"
                placeholder="Choose an image file"
                dense
                hide-details="auto"
                accept=".gif, .png, .svg, .tif, .webp, .jpg, .jpeg"
                class="logo-upload-input">
              </v-file-input>
            </div>

            <div class="info-section">
              <h2 class="section-title">Office Information</h2>
              <div class="form-row">
                <v-text-field
                  :rules="[rules.alpha_char, rules.max50]"
                  label="Address"
                  v-model="form.address1"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
                <v-text-field
                  :rules="[rules.alpha_char, rules.max50]"
                  label="Unit"
                  v-model="form.address2"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
              </div>
              <div class="form-row">
                <v-text-field
                  :rules="[rules.alpha_char, rules.max50]"
                  label="City"
                  v-model="form.city"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
                <v-text-field
                  :rules="[rules.alpha_char, rules.max2]"
                  label="State"
                  v-model="form.state"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
              </div>
              <div class="form-row">
                <v-text-field
                  :rules="[rules.zip, rules.max25]"
                  label="Zip Code"
                  v-model="form.zip"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
                <v-text-field
                  :rules="[rules.phone]"
                  label="Phone"
                  v-model="form.phone"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
              </div>
              <div class="form-row">
                <v-text-field
                  :rules="[rules.email]"
                  label="Email"
                  v-model="form.email"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
                <v-text-field
                  label="Privacy Contact"
                  v-model="form.privacyContact"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
              </div>
              <div class="form-row">
                <v-text-field
                  label="Website"
                  v-model="form.website"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
                <v-select
                  :items="timezones"
                  item-text="name"
                  item-value="location"
                  label="Timezone"
                  v-model="form.timezone"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
              </div>
              <div class="form-row">
                <v-text-field
                  label="Intake Form Update Interval (days)"
                  v-model="form.intakeFormUpdateInterval"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
              </div>
            </div>

            <div class="info-section">
              <h2 class="section-title">URLs</h2>
              <div class="form-row">
                <v-text-field
                  label="Address Url"
                  v-model="form.addressUrl"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
                <v-text-field
                  label="Billing Url"
                  v-model="form.billingUrl"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
              </div>
              <div class="form-row">
                <v-text-field
                  label="Booking Url"
                  v-model="form.bookingUrl"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
                <v-text-field
                  label="Financing Url"
                  v-model="form.financingUrl"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
              </div>
              <div class="form-row">
                <v-text-field
                  label="Referral Url"
                  v-model="form.referralUrl"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
                <v-text-field
                  label="Services Url"
                  v-model="form.servicesUrl"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
              </div>
              <div class="form-row">
                <v-text-field
                  label="Team Url"
                  v-model="form.teamUrl"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
                <v-text-field
                  label="Facebook Url"
                  v-model="form.facebookUrl"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
              </div>
              <div class="form-row">
                <v-text-field
                  label="Instagram Url"
                  v-model="form.instagramUrl"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
                <div></div>
              </div>
            </div>

            <div class="info-section">
              <h2 class="section-title">Appearance</h2>
              <div class="form-row">
                <v-text-field
                  label="Custom Header Color"
                  v-model="form.headerColor"
                  class="line-input custom-filled"
                  dense
                  hide-details="auto" />
                <div></div>
              </div>
              <v-checkbox
                label="Use White Behind Logo"
                v-model="form.whiteBehindLogo"
                hide-details />
            </div>

            <div class="form-actions">
              <v-btn class="btn-primary" @click="updateClientInfo">Save</v-btn>
              <v-btn class="btn-secondary" @click="cancelUpdate">Cancel</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import Utils from '../../../src/utils.js';
import DataService from '../../../_services/DataService';
import ValidateService from '../../../_services/ValidateService';

export default {
  name: 'CompanyConfig',
  data() {
    return {
      form: {
        timezone: '',
        headerColor: '',
        whiteBehindLogo: false,
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        email: '',
        privacyContact: '',
        addressUrl: '',
        billingUrl: '',
        bookingUrl: '',
        facebookUrl: '',
        financingUrl: '',
        instagramUrl: '',
        referralUrl: '',
        servicesUrl: '',
        teamUrl: '',
        website: '',
        intakeFormUpdateInterval: '',
      },
      logo: '',
      convertedLogo: '',
      originalLogo: '',
      timezones: this.getTimezoneArr(),
      loading: true,
      rules: ValidateService.validators,
      largeImg: false,
    };
  },
  methods: {
    cancelUpdate() {
      location.reload();
    },
    getTimezoneArr() {
      return Utils.getUsTimezones();
    },
    async getClientInfo() {
      this.loading = true;

      const client = await DataService.getClientDetails();
      this.form = {
        timezone: client.timezone,
        headerColor: client.customHeaderColor,
        whiteBehindLogo: client.whiteBehindLogo,
        address1: client.address1,
        address2: client.address2,
        city: client.city,
        state: client.state,
        zip: client.zip,
        phone: Utils.formatPhone(client.phone),
        email: client.email,
        privacyContact: client.privacyContact,
        addressUrl: client.addressUrl,
        billingUrl: client.billingUrl,
        bookingUrl: client.bookingUrl,
        facebookUrl: client.facebookUrl,
        financingUrl: client.financingUrl,
        instagramUrl: client.instagramUrl,
        referralUrl: client.referralUrl,
        servicesUrl: client.servicesUrl,
        teamUrl: client.teamUrl,
        website: client.website,
        intakeFormUpdateInterval: client.intakeFormUpdateInterval,
      };

      this.convertedLogo = client.clientLogo;
      this.originalLogo = client.clientLogo;
      this.form.logo = null;

      this.loading = false;
    },
    displayError(msg) {
      let str = 'Something went wrong';

      if (msg !== undefined) str = msg;
      this.$root.$emit('raise_alert', {
        color: 'info',
        text: str,
      });
    },
    async updateClientInfo() {
      const body = {
        timezone: this.form.timezone,
        customHeaderColor: this.form.headerColor,
        whiteBehindLogo: this.form.whiteBehindLogo,
        address1: this.form.address1,
        address2: this.form.address2,
        city: this.form.city,
        state: this.form.state,
        zip: this.form.zip,
        phone: this.form.phone,
        email: this.form.email,
        privacyContact: this.form.privacyContact,
        clientLogo: this.convertedLogo,
        addressUrl: this.form.addressUrl,
        billingUrl: this.form.billingUrl,
        bookingUrl: this.form.bookingUrl,
        facebookUrl: this.form.facebookUrl,
        financingUrl: this.form.financingUrl,
        instagramUrl: this.form.instagramUrl,
        referralUrl: this.form.referralUrl,
        servicesUrl: this.form.servicesUrl,
        teamUrl: this.form.teamUrl,
        website: this.form.website,
        intakeFormUpdateInterval: this.form.intakeFormUpdateInterval,
      };

      const response = await DataService.updateClientInfo(DataService.getClientId(), body);
      if (response.status === 200) {
        this.$root.$emit('raise_alert', {
          color: 'success',
          text: 'Your changes have been saved.',
        });
        await this.getClientInfo();
      } else {
        const msg = response.status === 413 ? 'Logo image upload too large. Please resize!' : 'Your changes could not be saved.';
        this.$root.$emit('raise_alert', {
          color: 'error',
          text: msg,
        });
      }
    },
    async convertLogo(img) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = () => {
          resolve(reader.result);
          this.convertedLogo = reader.result;
        };
        reader.onerror = (error) => reject(error);
      });
    },
  },
  async mounted() {
    await this.getClientInfo();
  },
};
</script>
<style lang="scss" scoped>
@import '@/scss/variables.scss';

$logo-border-color: #e2e8f0;
$no-logo-bg-color: #f8fafc;
$no-logo-text-color: #9ca3af;

.loading-container {
  text-align: center;
  padding: 80px 24px;
}

.logo-preview {
  margin-bottom: 24px;
  
  .logo-container {
    border: 1px solid $logo-border-color;
    border-radius: 8px;
    padding: 16px;
    display: inline-block;
    background: white;
  }
  
  .no-logo {
    padding: 40px;
    background: $no-logo-bg-color;
    border: 1px solid $logo-border-color;
    border-radius: 8px;
    color: $no-logo-text-color;
    text-align: center;
    font-size: 14px;
  }
}

.logo-upload-input {
  cursor: pointer;
  
  ::v-deep .v-input__prepend-outer {
    margin-right: 12px;
  }
  
  ::v-deep .v-input__slot {
    cursor: pointer;
  }
  
  ::v-deep input {
    cursor: pointer;
  }
}
</style>
